import React from 'react'
import {SubHeroText} from './Styles'
function Work() {
    return (
        <div class="bg-stone-900 py-5 " id="workSection">
            <div class="container text-white px-5 pt-5">
                <SubHeroText>
                    MY WORK
                </SubHeroText>
                <div class="row my-3 py-5">
                    <h6>
                        I was never the best at school or academics, I’m just a super curious guy. I spend a lot of time building software and electronics, but there’s also a lot more to it. 
                    </h6>
                </div>
                <div class="row my-3 py-5">
                    <div class="col col-md-4 col-sm-12 col-xs-12">
                            <p class="w-100 h5 mb-3">Software Development</p>
                        
                            <li>Java/C# Automation. CPU bound business logic.</li>
                            <li>Low level/embedded IoT programming.</li>
                            <li>Cloud computing, micro-services, API’s, full stack web apps.</li>
                        
                    </div>
                    <div class="col col-md-4 col-sm-12 col-xs-12">
                        <p class="w-100 h5 mb-3">Electronics</p>
                        
                        <li>C++/ Arduino, headless Raspberry PI Cluster.</li>
                        <li>3 Ph AC Brushless motors, PID controller.</li>
                        <li>Power Electronics, battery technology.</li>
                    
                    </div>
                    <div class="col col-md-4 col-sm-12 col-xs-12">
                        <p class="w-100 h5 mb-3">Open Source Community</p>
                        
                        <li>Git/Github Open-source projects.</li>
                        <li>Startup founder</li>
                    </div>
                    
                </div>
            </div>
        </div>
    )
}

export default Work
